import DictionaryIcon_Trans from "../../../assets/UI/DictionaryIcon_Trans.png";
import SearchBarDictionary from "../DictionaryComponents/SearchBar_Dictionary/SearchBar_Dictionary";
import "../Dictionary.css";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";

import WordGrid from "../DictionaryComponents/WordGrid/WordGrid";
import WordGridLarge from "../DictionaryComponents/WordGrid/WordGridLarge";

import { Hours } from "../../../SubjectData/BasicWords/Time";
import { Minutes } from "../../../SubjectData/BasicWords/Time";
import { TimeWords } from "../../../SubjectData/BasicWords/Time";
import { HoursMins } from "../../../SubjectData/BasicWords/Time";
import { PartsOfTheDay } from "../../../SubjectData/BasicWords/Time";
import { DaysOfTheWeek } from "../../../SubjectData/BasicWords/Time";
import { Months } from "../../../SubjectData/BasicWords/Time";
import { Durations } from "../../../SubjectData/BasicWords/Time";

import Popup from "../../../Components/Popup/Dictionary_Popup";
import {useState} from "react";

export default function TimeDictionary(){

    const [openPopup, setOpenPopup] = useState(null);

    const allData = [
        ...Hours, 
        ...Minutes,
        ...TimeWords,
        ...HoursMins,
        ...PartsOfTheDay,
        ...DaysOfTheWeek,
        ...Months,
        ...Durations
    ];
    
        return(
       
               <div>
                   <HeaderNavNTM GoBack_to="/TimeNav"/>
                   <div className="blue-header-dict">
                       
                       <img className="DictionaryImage" src={DictionaryIcon_Trans} alt="Dictionary"></img>
                      
                         <SearchBarDictionary data={allData} onSelectItem={setOpenPopup} />
                       
                   </div>
       
                   <div>
                       
                       <WordGrid data={Hours} title="Hours" onSelectItem={setOpenPopup} />
                       <WordGrid data={Minutes} title="Minutes" onSelectItem={setOpenPopup} />    
                       <WordGridLarge data={HoursMins} title="Hours + Minutes" onSelectItem={setOpenPopup} />      
                       <WordGrid data={TimeWords} title="Time Words" onSelectItem={setOpenPopup} />    
                       <WordGrid data={PartsOfTheDay} title="Parts of the Day" onSelectItem={setOpenPopup} />    
                       <WordGrid data={DaysOfTheWeek} title="Days of the Week" onSelectItem={setOpenPopup} />    
                       <WordGrid data={Months} title="Months" onSelectItem={setOpenPopup} />    
                                   
                       <Popup item={openPopup} onClose={() => setOpenPopup(null)} />
                  
                   </div>
                   
               </div>
       
           );
       
       }
       
    
    
    //Resources
        //Making a search bar
            //https://builtin.com/articles/react-search-bar